import { useLocation, useNavigate } from "react-router-dom";
import "../styles/PdfViewer.css";

function PdfViewer() {
  const location = useLocation();
  const navigate = useNavigate();

  const rawUrl = location.state?.pdfUrl;

  const pdfUrl = rawUrl?.startsWith("http")
    ? rawUrl
    : `https://api.joss-serveur.duckdns.org${rawUrl}`;

  const title = location.state?.title || "Planche";

  const viewerUrl =
    `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(pdfUrl)}`;

  return (
    <div className="pdf-viewer-page">
      <div className="pdf-header">
        <button
          className="back-btn"
          onClick={() => navigate(-1)}
        >
          ←
        </button>

        <h2>{title}</h2>
      </div>

      <div className="pdf-container">
        <iframe
          src={viewerUrl}
          title="PDF Viewer"
          style={{
            width: "100%",
            height: "80vh",
            border: "none",
            borderRadius: "16px",
            background: "#111",
          }}
        />
      </div>
    </div>
  );
}

export default PdfViewer;